function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectionZone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.127 276.434c-10.67-34.706-57.361-83.936-71.331-98.121l-57.532 22.716-1.143-.607c-13.357 38.529-10.926 105.327-10.926 105.327.173.204.334.414.503.62 55.724 1.078 131.245-26.651 140.429-29.935z",
    style: {},
    fill: "#fd6050",
    "data-original": "#fd6050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.654 250.679c-26.17-34.812-22.059-78.472-19.856-92.523l-69.624-44.56-44.202 37.855v26.792l-.176.069c13.97 14.185 60.661 63.415 71.331 98.121 26.742-8.646 53.067-21.391 62.527-25.754z",
    style: {},
    fill: "#fd8f01",
    "data-original": "#fd8f01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.632 200.592 55 171.59S-.008 202.881 12.308 283.828c0 0 27.641-.851 43.723 1.191 16.082 2.041 32.193 8.533 42.675 20.899 0 0-2.431-66.797 10.926-105.326z",
    style: {},
    fill: "#d63b78",
    "data-original": "#d63b78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.654 250.679c46.444-21.42 102.953-51.823 132.654-77.902-4.678-8.491-8.442-19.106-10.052-32.343l-142.394 17.763-.064-.041c-2.203 14.051-6.313 57.711 19.856 92.523z",
    style: {},
    fill: "#fdcb50",
    "data-original": "#fdcb50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.308 172.777c-29.7 26.079-86.21 56.481-132.654 77.902l.008.011-.008-.011a893.251 893.251 0 0 1-26.812 11.858c8.99 6.153 44.275 31.973 47.986 60.525 17.276-1.44 36.112-1.857 55.968-1.021 13.749-38.08 75.682-103.77 89.635-118.263-.203-.067-20.86-6.926-34.123-31.001z",
    style: {},
    fill: "#67ccd1",
    "data-original": "#67ccd1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 259.222s-28.681-14.813-31.555-55.439l-.013-.004c-13.953 14.493-75.886 80.184-89.635 118.263 25.339 1.067 52.34 4.177 79.889 9.817-.001-.001 28.919-30.28 41.314-72.637z",
    style: {},
    fill: "#1a8dc2",
    "data-original": "#1a8dc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.842 262.537-.924.39c-10.818 4.545-53.479 19.97-63.187 22.953-.352 8.487-1.391 49.164 9.787 69.729 8.354-6.254 17.781-12.093 28.057-16.523 17.84-7.691 43.593-13.466 74.254-16.022-3.711-28.555-38.997-54.375-47.987-60.527z",
    style: {},
    fill: "#91b706",
    "data-original": "#91b706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.731 285.879c-36.71 11.28-76.283 19.752-112.032 20.489 14.572 17.754 15.541 43.435 28.083 62.75 11.441 17.62 32.689 28.388 53.663 27.196 0 0 15.323-22.177 40.074-40.707-11.179-20.564-10.14-61.24-9.788-69.728z",
    style: {},
    fill: "#b1d952",
    "data-original": "#b1d952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.797 283.658s27.641-.851 43.723 1.191c16.082 2.041 32.193 8.534 42.675 20.9 15.063 17.772 15.899 43.831 28.586 63.371 11.441 17.62 32.689 28.388 53.663 27.196 0 0 27.411-39.675 68.13-57.23s122.661-25.129 210.11-7.226c0 0 28.92-30.28 41.315-72.636 0 0-28.681-14.813-31.555-55.439 0 0-37.991-12.394-44.189-63.349l-142.394 17.763-69.688-44.601-44.202 37.855v26.793l-57.708 22.785-55.775-29.609c.001-.003-55.006 31.288-42.691 112.236z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#052a75",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#052a75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectionZone);
export default __webpack_public_path__ + "static/media/protectionZone.9802082068ac7eea94d02ee72619b7ac.svg";
export { ForwardRef as ReactComponent };